'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styled = require('./styled');

var _styled2 = _interopRequireDefault(_styled);

var _animations = require('../../hoc/animations');

var _animations2 = _interopRequireDefault(_animations);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var Animation =
/*#__PURE__*/
function (_react2$default$Compo) {
  _inherits(Animation, _react2$default$Compo);

  function Animation() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Animation);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Animation)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.elementRef = _react2.default.createRef(), _this.state = {
      active: false,
      options: {}
    }, _this.play = function (options) {
      if (!_this.state.active) {
        _this.setState({
          active: true,
          options: options
        });
      }
    }, _this.stop = function () {
      _this.setState({
        active: false,
        options: {}
      });
    }, _temp));
  }

  _createClass(Animation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          register = _this$props.animate.register,
          id = _this$props.id;

      if (register) {
        register(id, this.play);
      }

      this.elementRef.current.addEventListener("animationend", this.stop);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          unregister = _this$props2.animate.unregister,
          id = _this$props2.id;

      if (unregister) {
        unregister(id);
      }

      this.elementRef.current.removeEventListener("animationend", this.stop);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          type = _props.type,
          props = _objectWithoutProperties(_props, ['type']);

      var _this$state = this.state,
          active = _this$state.active,
          options = _this$state.options;
      return _react2.default.createElement(_styled2.default, _extends({
        className: active ? type : '',
        ref: this.elementRef
      }, options, props));
    }
  }]);

  return Animation;
}(_react2.default.Component);

exports.default = (0, _animations2.default)(Animation);